<template>
  <span>
    <Select :value="values[0]" @input="flowChange"  style="width: 150px;" placeholder="场景" clearable transfer>
      <Option v-for="flow in flows" :key="flow.id" :value="flow.id">{{flow.name}}</Option>
    </Select>
    -
    <Select :value="values[1]"  @input="flowNodeChange" style="width: 150px; margin-left: '10px'" placeholder="节点" clearable transfer>
      <Option v-for="node in flowNodes" :key="node.id" :value="node.id">
        {{node.name}}
      </Option>
    </Select>
  </span>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    formItemProps: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    ...mapState('flow', [
			'flows'
    ]),
    values() {
      const values = this.value.split(',');
      return [values[0] || '', values[1] || '']
    },
    flowNodes() {
      const curFlow = this.flows.find(flow => flow.id === this.values[0])
      if (!curFlow) return [];
      return curFlow.nodes
    }
  },
  methods: {
    flowChange(val) {
      if (!val) return;
      this.$emit('input', val)
    },
    flowNodeChange(val) {
      if (!val) return;
      this.$emit('input', `${this.values[0]},${val}`)
    }
  }
}
</script>